var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, query } from "lit/decorators.js";
import { html, css } from "lit";
import { PICDateValidate, PICDateEditing, PICValidate, PICMinDate, PICMaxDate, PICInput, stringDecoder, stringDateDecoder, booleanDecoder, Calendar, Position, parseFormat, customElement, arrayDecoder, PIC } from '../Internals';
let PICDate = class PICDate extends PICInput {
    get submitValue() {
        if (this.editing)
            return '';
        if (this.calendar)
            return this.calendar.toReturnValue();
        if (this.hasInvalidDate)
            return 'null';
        return '';
    }
    constructor() {
        super();
        this.format = '';
        this.max = '2038-01-19';
        this.min = '1970-01-01';
        this.info = 'Select date';
        this.mode = 'single';
        this.hasWeekNo_ = false;
        this.removeClearBtn_ = false;
        this.interval = false;
        this.initVal = '';
        this.isSimple = false;
        this.pos = Position.Day;
        this.sep = '';
        this.editing = false;
        this.editVal = '';
        this.fullYear = false;
        this.isAndroid = false;
        this.updateStarted = false;
        this.hasInvalidDate = false;
        this.calendar = null;
    }
    getBlankValue() {
        let tmp = parseFormat(this.format);
        return tmp.posArr.map(p => this.fullYear && p == Position.Year ? '––––' : '––').join(this.sep);
    }
    tearDown() {
        this.valid = null;
    }
    startup() {
        if (!this.valid)
            this.valid = new PICValidate([], this);
        if (this.format === '') {
            this.format = PIC.getInstance.userConfig.dateFormat;
        }
        this.isAndroid = (navigator.userAgent.toLowerCase().indexOf("android") > -1);
        if (!this.value || !this.calendar) {
            let tmp = parseFormat(this.format);
            this.fullYear = tmp.fullYear;
            this.sep = tmp.sep;
            if (this.userHasInteracted && this.value == this.getBlankValue()) {
                let d = new Date();
                this.value = `${d.getFullYear()}${(d.getMonth() + 1 + '').padStart(2, '0')}${(d.getDate() + '').padStart(2, '0')}`;
            }
            if (!this.value) {
                // this.value = tmp.posArr.map(p => this.fullYear && p == Position.Year ? '––––' : '––' ).join(this.sep);
                // tmp.posArr.forEach(p => {this.pos = p; this.clearPos(false)})
                this.value = this.getBlankValue();
                this.editVal = this.getBlankValue();
            }
            if (tmp.sep.length == 0) {
                this.isSimple = true;
                if (this.value && this.value != this.getBlankValue())
                    this.calendar = new Calendar({ dateString: this.value, fullYear: true, sep: '', order: [Position.Year, Position.Month, Position.Day] });
                let ref = this;
                this.valid.add(new PICDateValidate(ref, { ruleType: 'validatedate', value: 'true' }));
            }
            else {
                this.setDisplayformat(tmp.posArr, tmp.fullYear);
                if (this.value && this.value != this.getBlankValue())
                    this.calendar = new Calendar({ dateString: this.value, fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
            }
        }
        this.valid.add(new PICMinDate(this, { ruleType: 'mindate', value: this.min }));
        this.valid.add(new PICMaxDate(this, { ruleType: 'maxdate', value: this.max }));
        this.valid.add(new PICDateEditing(this, { ruleType: 'validatedate', value: 'true' }));
        this.initVal = this.submitValue;
    }
    connectedCallback() {
        super.connectedCallback();
        this.startup();
    }
    static get styles() {
        const defaultStyle = css `
            :host {
                --annoyingzindexrectifier: 5; /*should always be 5, if we ever get rid of oldstyle */
            }
            .picker {
                z-index: var(--annoyingzindexrectifier);
            }
            .picker.new{
                position: absolute;
                top: 40px;    
            }
            .picker.low {
                top: 67px;
            }
            .picker.medium {
                top: 59px;
            }
            .picker.high {
                top: 38px; 
            }
            .picker.inline {
                top: 28px;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    // Save caret position before re-render
    willUpdate() {
        if (!this.isSimple)
            if (this.inputField)
                this.pos = this.getPos();
    }
    //Select saved caret position
    updated() {
        //Tmp disable on Safari -> causes infinite loop...
        if (window.navigator.userAgent.indexOf('Safari/') > -1
            && window.navigator.userAgent.indexOf('Chrome/') === -1
            && window.navigator.userAgent.indexOf('Chromium/') === -1) { }
        else if (!this.isSimple)
            this.setPos(this.pos);
    }
    setValue(value) {
        let tmp = parseFormat(this.format);
        this.fullYear = tmp.fullYear;
        this.sep = tmp.sep;
        if (tmp.sep.length === 0) {
            this.calendar = new Calendar({ dateString: value, fullYear: true, sep: '', order: [Position.Year, Position.Month, Position.Day] });
        }
        else {
            this.calendar = new Calendar({ dateString: value, fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
        }
    }
    // handle movement of selection
    moveCaret(direction) {
        let pos = this.getPos();
        if (direction == 'ArrowRight') {
            if (this.arrPos.indexOf(pos) >= 2) {
                return;
            }
            else {
                //@ts-ignore
                this.setPos(this.arrPos[this.arrPos.indexOf(pos) + 1]);
            }
        }
        else {
            if (this.arrPos.indexOf(pos) == 0) {
                return;
            }
            else {
                //@ts-ignore
                this.setPos(this.arrPos[this.arrPos.indexOf(pos) - 1]);
            }
        }
    }
    addToClipBoard() {
        var _a, _b;
        const el = document.createElement('textarea');
        el.value = (_b = (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.inputField.select();
        this.setPos(this.getPos());
    }
    focus() {
        this.inputField.focus();
    }
    inputNumber(iNum) {
        var _a, _b, _c, _d, _e;
        let partialVal = ''; //The value that is currently in the position being edited (before input)
        let parts; //year, month, day
        let newPos; //what position to change to, if any
        let replace = false;
        if (!this.userHasInteracted) {
            if (this.value == this.getBlankValue())
                replace = true;
            this.handleUserInteraction();
        }
        if (!this.editing) {
            this.clearPos(true);
            parts = this.value.split(this.sep);
        }
        else {
            parts = this.editVal.split(this.sep);
        }
        let max;
        switch (this.getPos()) {
            case Position.Day: {
                // max = this.calendar!.getDaysInCurMonth();
                max = 31;
                break;
            }
            case Position.Month: {
                max = 12;
                break;
            }
            case Position.Year: {
                if (this.fullYear)
                    max = 9999;
                else
                    max = 99;
                break;
            }
            default: {
                max = 9999; //to fix assignment
                break;
            }
        }
        let partialIsNaN = false;
        partialVal = (_a = parts[this.arrPos.indexOf(this.getPos())]) !== null && _a !== void 0 ? _a : '';
        partialVal = (partialVal + '').replace(/[–]+/g, '');
        if (isNaN(parseInt(partialVal))) {
            partialVal = '0';
            partialIsNaN = true;
        }
        //New Position Checks
        //these are all the same, but different positions (and length for year)
        const dayCheck = this.pos === Position.Day
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= 2 //does not work on first cipher because partialVal is set to '0'
            && !partialIsNaN
            && partialVal.length !== 2; //When entering a field that was previously filled with fx '01'
        const monthCheck = this.pos === Position.Month
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= 2
            && !partialIsNaN
            && partialVal.length !== 2;
        const yearCheck = this.pos === Position.Year
            && parseInt(partialVal + iNum) <= max
            && (partialVal + iNum).length >= String(max).length //2 or 4
            && !partialIsNaN;
        const shouldGoNext = dayCheck || monthCheck || yearCheck;
        PIC.getInstance.msg('dateChecks', dayCheck, monthCheck, yearCheck, partialVal, iNum, partialIsNaN);
        if (shouldGoNext) {
            partialVal = parseInt(partialVal) + '' + iNum;
            newPos = this.arrPos[this.arrPos.indexOf(this.getPos()) + 1];
            //newPos will be undefined if at last pos and last cipher... which "fails successfully" but...
        }
        else if (this.pos === Position.Year && (partialVal + iNum).length < String(max).length) {
            //If in year, and not done, continue concatenating
            if (partialIsNaN)
                partialVal = '' + iNum;
            else
                partialVal = partialVal + iNum;
            newPos = this.getPos();
        }
        else {
            partialVal = iNum + '';
            newPos = this.getPos();
        }
        parts[this.arrPos.indexOf(this.getPos())] = partialVal;
        (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.setValue(Number((_c = parts[this.arrPos.indexOf(Position.Day)]) === null || _c === void 0 ? void 0 : _c.replace(/[–]+/g, '')), Number((_d = parts[this.arrPos.indexOf(Position.Month)]) === null || _d === void 0 ? void 0 : _d.replace(/[–]+/g, '')), Number((_e = parts[this.arrPos.indexOf(Position.Year)]) === null || _e === void 0 ? void 0 : _e.replace(/[–]+/g, '')));
        if (replace) {
            parts = this.getBlankValue().split(this.sep);
        }
        parts[this.arrPos.indexOf(this.getPos())] = this.getPos() == Position.Year && this.fullYear
            ? partialVal.padStart(4, '–')
            : partialVal.padStart(2, '–');
        this.editVal = parts.join(this.sep);
        this.value = this.editVal;
        this.setPos(newPos);
    }
    reset() {
        var _a, _b, _c;
        this.editing = false;
        (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.reset();
        this.value = (_c = (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : this.getBlankValue();
        this.requestUpdate();
    }
    increment(shift) {
        var _a, _b, _c, _d, _e;
        let pos;
        if (!shift)
            pos = this.getPos();
        else
            pos = Position.Month;
        switch (pos) {
            case Position.Day: {
                (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.addDay();
                break;
            }
            case Position.Month: {
                (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.addMonth();
                break;
            }
            case Position.Year: {
                (_c = this.calendar) === null || _c === void 0 ? void 0 : _c.addYear();
                break;
            }
        }
        this.editing = false;
        this.value = (_e = (_d = this.calendar) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : this.getBlankValue();
    }
    decrement(shift) {
        var _a, _b, _c, _d, _e;
        let pos;
        if (!shift)
            pos = this.getPos();
        else
            pos = Position.Month;
        switch (pos) {
            case Position.Day: {
                (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.subtDay();
                break;
            }
            case Position.Month: {
                (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.subtMonth();
                break;
            }
            case Position.Year: {
                (_c = this.calendar) === null || _c === void 0 ? void 0 : _c.subtYear();
                break;
            }
        }
        this.editing = false;
        this.value = (_e = (_d = this.calendar) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : this.getBlankValue();
    }
    setDisplayformat(iPos, iFullYear) {
        let posCounter = 0;
        this.positions = new Map();
        this.arrPos = iPos;
        for (let i = 0; 3 > i; i++) {
            //@ts-ignore
            this.positions.set(iPos[i], [posCounter, (posCounter += 2)]);
            if (iFullYear && iPos[i] == Position.Year) {
                //@ts-ignore
                this.positions.get(iPos[i])[1] = posCounter += 2;
            }
            posCounter++;
        }
    }
    clearPos(refresh) {
        var _a, _b;
        if (!this.editing) {
            this.editing = true;
            this.editVal = (_b = (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : this.getBlankValue();
        }
        let tmp = this.editVal.split(this.sep);
        tmp[this.arrPos.indexOf(this.getPos())] = `${this.fullYear && this.getPos() == Position.Year ? '––––' : '––'}`;
        this.editVal = tmp.join(this.sep);
        if (refresh)
            this.value = this.editVal;
    }
    getPos() {
        let caretPos = this.inputField.selectionStart;
        for (var [key, val] of this.positions) {
            if (caretPos >= val[0] && caretPos <= val[1]) {
                return key;
            }
        }
        return Position.All;
    }
    setPos(position) {
        if (position === Position.All) {
            this.inputField.select();
        }
        else {
            let pos = this.positions.get(position);
            if (pos) {
                this.inputField.setSelectionRange(pos[0], pos[1]);
            }
        }
    }
    leaveCheck(e) {
        var _a, _b;
        this.editing = false;
        this.showFullError = false;
        //Fix here instead of PICInput-changeHandler, because this checks validation first
        if (this.customError && this.submitValue !== this.initValue_) {
            (_a = this.valid) === null || _a === void 0 ? void 0 : _a.remove(this.customError);
            this.customError = null;
            this.validate();
        }
        if (this.value == this.getBlankValue()) {
            this.calendar = null;
            this.valid = null;
            this.userHasInteracted = false;
        }
        if (!this.isSimple) {
            let parsed = parseFormat(this.format);
            if (this.value.length === this.format.length) {
                let separatedVals = this.value.split(parsed.sep);
                let day = separatedVals[parsed.posArr.indexOf(Position.Day)];
                let month = separatedVals[parsed.posArr.indexOf(Position.Month)];
                let year = separatedVals[parsed.posArr.indexOf(Position.Year)];
                if (!isNaN(Number(day)) && !isNaN(Number(month)) && !isNaN(Number(year))) {
                    if (this.calendar && this.calendar.getDaysInCurMonth(Number(month) - 1) < Number(day)) {
                        this.calendar = null;
                        this.hasInvalidDate = true;
                    }
                }
            }
            this.validate();
            if (this.validState.length > 0) {
                this.requestUpdate();
                return;
            }
            if (this.editing) { //TODO clean up. This will never be true here. It is set as false first thing in leaveCheck()
                let testRes = this.valid.isInvalid(this.inputField.value, true);
                if (typeof testRes == 'boolean') {
                    this.validState = [];
                }
                else {
                    this.validState = testRes;
                    return;
                }
            }
        }
        else {
            let testRes = this.valid.isInvalid(this.submitValue, false);
            if (typeof testRes == 'boolean') {
                this.validState = [];
                let tmpDate = parse(this.inputField.value);
                (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.setDate(tmpDate);
            }
            else {
                this.validState = testRes;
            }
            function parse(str) {
                let y = parseInt(str.substr(0, 4)), m = parseInt(str.substr(4, 2)) - 1, d = parseInt(str.substr(6, 2));
                var D = new Date(y, m, d);
                return D.getFullYear() == y && D.getMonth() == m && D.getDate() == d ? D : 'invalid date';
            }
        }
        this.changeHandler(e);
    }
    // On first click -> select all 
    firstClick() {
        "use strict";
        let selected = this.inputField;
        let myHandler = function () {
            let click = false;
            return function () {
                if (click === false) {
                    selected.select();
                    click = true;
                }
            };
        }();
        this.inputField.addEventListener('click', myHandler, false);
    }
    ;
    changeHandler(e) {
        this.validateSubmit();
        if (!this.updateStarted)
            this.updateStarted = super.changeHandler(e);
        return this.updateStarted;
    }
    handleClick(e) {
        if (!this.isSimple && e.target) {
            this.setPos(this.getPos());
        }
    }
    forceClose() {
        if (this.datePicker)
            this.datePicker.hide();
    }
    // override keyEvents
    handleKeyEvents(e) {
        if (!this.isSimple) {
            if (![
                'Escape', 'Tab', 'Alt', 'F1',
                'F2', 'F3', 'F4', 'F5', 'F6',
                'F7', 'F8', 'F9', 'F10', 'F11', 'F12'
            ].includes(e.key) && !(e.ctrlKey && e.key == 'v')) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.hasInvalidDate = false;
            }
            /* This is to control what keys count as a user date change interaction */
            // numeric is handled seperately
            if (!this.userHasInteracted && !this.calendar === null) {
                if (['ArrowUp', 'ArrowDown', '.'].includes(e.key)) {
                    this.handleUserInteraction();
                }
            }
            if (['ArrowLeft', 'ArrowRight'].includes(e.key)) {
                this.moveCaret(e.key);
            }
            else if (this.calendar === null && ['ArrowUp'].includes(e.key)) {
                let tmp = parseFormat(this.format);
                this.calendar = new Calendar({ fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
                this.increment(e.shiftKey);
            }
            else if (['ArrowUp'].includes(e.key)) {
                this.increment(e.shiftKey);
            }
            else if (this.calendar === null && ['ArrowDown'].includes(e.key)) {
                let tmp = parseFormat(this.format);
                this.calendar = new Calendar({ fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
                this.decrement(e.shiftKey);
            }
            else if (['ArrowDown'].includes(e.key)) {
                this.decrement(e.shiftKey);
            }
            else if (['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key)) {
                if (this.calendar === null) {
                    let tmp = parseFormat(this.format);
                    this.calendar = new Calendar({ fullYear: tmp.fullYear, sep: tmp.sep, order: tmp.posArr });
                }
                this.inputNumber(parseInt(e.key));
            }
            else if (['.'].includes(e.key)) {
                this.reset();
            }
            else if (e.ctrlKey && e.key == 'c') {
                this.addToClipBoard();
                // } else if (this.inputField.selectionStart === 0 && this.inputField.selectionEnd === this.inputField.value.length && ['Enter', ' '].includes(e.key)) {
                //     this.iconClick();
                //  To do - use later and fix tabbing (don't tab out of the calender when it's open)
            }
            else if (['Enter'].includes(e.key)) {
                this.leaveCheck();
                if (!this.changeEvent)
                    this.enterSubmit(e);
            }
            else if (e.ctrlKey && e.key == 'a') {
                this.inputField.select();
            }
            else if (['Delete', 'Backspace'].includes(e.key)) {
                if (this.inputField.selectionStart === 0 && this.inputField.selectionEnd === this.inputField.value.length) {
                    this.calendar = null; // sets inputfields visual to --.. and so on 
                    this.value = this.getBlankValue(); // inputfield is clear until unFocused (so keep it)
                    this.editVal = this.getBlankValue(); // doesn't look like it does anything
                }
                else {
                    this.clearPos(true);
                }
            }
            else {
                return false;
            }
        }
    }
    focusHandler() {
        this.showFullError = true;
        this.inputField.select();
        this.firstClick();
        this.requestUpdate();
    }
    //TODO assume same as display date first, if not valid date try to parse
    //TODO YYYY/YY
    handlePaste(e) {
        var _a, _b, _c;
        this.hasInvalidDate = false;
        if (!this.isSimple) {
            e.preventDefault();
            e.stopImmediatePropagation();
            if (e.type == 'paste') {
                if (e.clipboardData) {
                    let paste = e.clipboardData.getData('text');
                    let sep = paste.replace(/[0-9]+/g, '').substr(0, 1);
                    let tmpDate;
                    if (sep.length == 0) {
                        // assume YYMMDD
                        tmpDate = new Date('20' + paste.substr(0, 2) + '-' + paste.substr(2, 2) + '-' + paste.substr(4, 2));
                        if (isNaN(tmpDate.getTime())) {
                            // try YYDDMM
                            tmpDate = new Date('20' + paste.substr(0, 2) + '-' + paste.substr(4, 2) + '-' + paste.substr(2, 2));
                        }
                    }
                    else {
                        tmpDate = new Date(paste.split(sep).join('-'));
                        /*this.calendar.setDate(new Date(paste.split(sep).join('-')));*/
                    }
                    if (isNaN(tmpDate.getTime())) {
                        // invalid paste, do nothing;
                        return;
                    }
                    else {
                        (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.setDate(tmpDate);
                        this.value = (_c = (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '';
                    }
                }
            }
        }
    }
    handleSelect(e) {
        var _a, _b, _c, _d;
        if (e.detail.type === 'cancel')
            this.hasInvalidDate = false;
        this.handleUserInteraction();
        if (!this.calendar)
            this.startup();
        if (this.eType == 'old' && this.density == 'old') {
            if ((_a = this.datePicker) === null || _a === void 0 ? void 0 : _a.startDate)
                (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.setDate(this.datePicker.startDate);
            this.datePicker.toggle();
            this.requestUpdate();
            this.changeHandler( /* NEEDS USEREVENT REF */);
        }
        else {
            if (e.detail.type == 'clear' || e.detail.date == null) {
                this.tearDown();
                this.userHasInteracted = false;
                this.calendar = null;
            }
            else {
                (_c = this.calendar) === null || _c === void 0 ? void 0 : _c.setDate(e.detail.date);
                this.editing = false;
            }
            if (e.detail.type == 'cancel') {
                this.datePicker.hide();
            }
            if (e.detail.type === 'cancel' || e.detail.type === 'select') {
                let inModal = ((_d = this.getRootNode().firstElementChild) === null || _d === void 0 ? void 0 : _d.nodeName) === 'PIC-MODAL';
                if (inModal)
                    this.focus();
            }
            this.requestUpdate();
            this.changeHandler( /* NEEDS USEREVENT REF */);
        }
        this.validate();
        this.showFullError = true;
    }
    handleUserInteraction() {
        if (!this.userHasInteracted) {
            this.userHasInteracted = true;
            if (!this.calendar) {
                this.tearDown();
                this.startup();
            }
        }
    }
    iconClick() {
        var _a, _b;
        this.userHasInteracted = true;
        this.datePicker.shouldHide = false;
        this.datePicker.data = {
            startDate: (_b = (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.getDateObject()) !== null && _b !== void 0 ? _b : new Date(),
            endDate: null,
            infoText: this.info,
            mode: 'single',
            parent: this,
            markRanges: this.markRanges_
        };
        this.datePicker.toggle();
    }
    clearDateInput() {
        this.inputField.value = '';
    }
    renderPicker() {
        if (this.eType == 'old' && this.density == 'old')
            return html `
                <div class="picker">
                    <pic-datepicker @valueselected=${this.handleSelect} id="datepicker"></pic-datepicker>
                </div>
            `;
        else
            return html `
                <pic-datepicker2 ?hasweekno=${this.hasWeekNo_} ?removeclearbtn=${this.removeClearBtn_} @clearDateField=${this.clearDateInput} @valueselected=${this.handleSelect} id="datepicker"></pic-datepicker2>
            `;
    }
    change(input) {
        input.type = 'text';
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.density == 'old') {
            this.style.setProperty('--annoyingzindexrectifier', '9001');
        }
        this.initValue_ = this.submitValue;
    }
    render() {
        var _a, _b;
        this.setComponentInlineStyle();
        if (!this.isSimple) {
            if (!this.editing && !this.hasInvalidDate)
                this.value = (_b = (_a = this.calendar) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : this.getBlankValue();
            else
                this.value = this.editVal;
        }
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class=${classMap(this.getContainerClassMap())} >
                <label class=${classMap(this.getInputLabelClass())} for=${this.id_ + '_inner'}>${this.label}</label>
                <input 
                    id=${this.id_ + '_inner'}
                    inputmode="numeric"
                    type="text"
                    class=${classMap(this.getInnerInputClass())}
                    ?disabled=${this.disabled_}
                    placeholder=${this.placeholder}
                    .value=${this.value}
                    @keydown=${this.handleKeyEvents}
                    @paste=${this.handlePaste}
                    @focusout=${this.leaveCheck}
                    @focusin=${this.focusHandler}
                    @click=${this.changeHandler}
                />
                ${this.icon.length > 0 ? this.renderIcon(this.disabled_) : ''}
                ${this.renderPicker()} 
                ${this.renderErr(this.showFullError)}
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
};
__decorate([
    query('.inner-input')
], PICDate.prototype, "inputField", void 0);
__decorate([
    query('#datepicker')
], PICDate.prototype, "datePicker", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDate.prototype, "format", void 0);
__decorate([
    property({ converter: stringDateDecoder })
], PICDate.prototype, "max", void 0);
__decorate([
    property({ converter: stringDateDecoder })
], PICDate.prototype, "min", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDate.prototype, "info", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICDate.prototype, "mode", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'hasweekno' })
], PICDate.prototype, "hasWeekNo_", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'removeclearbtn' })
], PICDate.prototype, "removeClearBtn_", void 0);
__decorate([
    property({ converter: arrayDecoder, attribute: 'markranges' })
], PICDate.prototype, "markRanges_", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PICDate.prototype, "interval", void 0);
PICDate = __decorate([
    customElement('pic-date')
], PICDate);
export { PICDate };
//# sourceMappingURL=PICDate.js.map